// Author thq
// Date 2024-06-07 16:43:17

class EmSparePartsInventoryCheckSic {
    constructor({
                    id = null,
                    sicIdSpi = '',
                    sicCheckDate = '',
                    sicBeforeQuantity = '',
                    sicAfterQuantity = '',
                    sicAdjustQuantity = '',
                    sicPrice = '',
                    sicSumPrice = '',
                    sicCheckResult = '',
                    sicChecker = '',
                    remark = ''
                }
                    = {}) {
        this.id = id;
        this.sicIdSpi = sicIdSpi;
        this.sicCheckDate = sicCheckDate;
        this.sicBeforeQuantity = sicBeforeQuantity;
        this.sicAfterQuantity = sicAfterQuantity;
        this.sicAdjustQuantity = sicAdjustQuantity;
        this.sicPrice = sicPrice;
        this.sicSumPrice = sicSumPrice;
        this.sicCheckResult = sicCheckResult;
        this.sicChecker = sicChecker;
        this.remark = remark;
    }
}

function newEntity() {
    return new EmSparePartsInventoryCheckSic();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.em.spareparts.emSparePartsInventoryCheckSic.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sicIdSpi',
            label: 'label.em.spareparts.emSparePartsInventoryCheckSic.grid.sicIdSpi',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'spiCodeSpa',
            label: 'label.em.spareparts.emSparePartsInventoryCheckSic.grid.spiCodeSpa',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'spiNameSpa',
            label: 'label.em.spareparts.emSparePartsInventoryCheckSic.grid.spiNameSpa',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sicBeforeQuantity',
            label: 'label.em.spareparts.emSparePartsInventoryCheckSic.grid.sicBeforeQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sicAfterQuantity',
            label: 'label.em.spareparts.emSparePartsInventoryCheckSic.grid.sicAfterQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sicAdjustQuantity',
            label: 'label.em.spareparts.emSparePartsInventoryCheckSic.grid.sicAdjustQuantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sicUnit',
            label: 'label.em.spareparts.emSparePartsInventoryCheckSic.grid.sicUnit',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sicPrice',
            label: 'label.em.spareparts.emSparePartsInventoryCheckSic.grid.sicPrice',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sicSumPrice',
            label: 'label.em.spareparts.emSparePartsInventoryCheckSic.grid.sicSumPrice',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sicCheckResult',
            label: 'label.em.spareparts.emSparePartsInventoryCheckSic.grid.sicCheckResult',
            sortable: true,
            form: {
                type: 'select',
                customClass: (row) => {
                    //超过一天的的变红
                    if (row.sicCheckResult === 1) {
                        return "text-danger"
                    } else if (row.sicCheckResult === 2) {
                        return "text-success"
                    }
                },
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '盘盈'},
                    {value: '2', text: '盘亏'}
                ]
            }
        },
        {
            key: 'sicCheckDate',
            label: 'label.em.spareparts.emSparePartsInventoryCheckSic.grid.sicCheckDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sicChecker',
            label: 'label.em.spareparts.emSparePartsInventoryCheckSic.grid.sicChecker',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sicCheckerName',
            label: 'label.em.spareparts.emSparePartsInventoryCheckSic.grid.sicCheckerName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.em.spareparts.emSparePartsInventoryCheckSic.grid.remark',
            sortable: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    sicIdSpiFilter: '',
    sicCheckDateRteFilter: '',
    sicCheckDateLteFilter: '',
    sicBeforeQuantityFilter: '',
    sicAfterQuantityFilter: '',
    sicAdjustQuantityFilter: '',
    sicPriceFilter: '',
    sicSumPriceFilter: '',
    sicCheckResultFilter: '',
    sicCheckerFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'sicIdSpiFilter',
        label: 'label.em.spareparts.emSparePartsInventoryCheckSic.filter.sicIdSpi',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emSparePartsInventorySpi'
            , correspondingField: 'id'
        }
    },
    {
        key: 'sicCheckDateRteFilter',
        label: 'label.em.spareparts.emSparePartsInventoryCheckSic.filter.sicCheckDateRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sicCheckDateLteFilter',
        label: 'label.em.spareparts.emSparePartsInventoryCheckSic.filter.sicCheckDateLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sicCheckResultFilter',
        label: 'label.em.spareparts.emSparePartsInventoryCheckSic.filter.sicCheckResult',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '盘盈'},
                {value: '2', text: '盘亏'}
            ]
        }
    },
    {
        key: 'sicCheckerFilter',
        label: 'label.em.spareparts.emSparePartsInventoryCheckSic.filter.sicChecker',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'sicIdSpi',
        label: 'label.em.spareparts.emSparePartsInventoryCheckSic.entity.sicIdSpi',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emSparePartsInventorySpi'
            , correspondingField: 'id'
        }
    },
    {
        key: 'sicCheckDate',
        label: 'label.em.spareparts.emSparePartsInventoryCheckSic.entity.sicCheckDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sicBeforeQuantity',
        label: 'label.em.spareparts.emSparePartsInventoryCheckSic.entity.sicBeforeQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sicAfterQuantity',
        label: 'label.em.spareparts.emSparePartsInventoryCheckSic.entity.sicAfterQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sicAdjustQuantity',
        label: 'label.em.spareparts.emSparePartsInventoryCheckSic.entity.sicAdjustQuantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sicPrice',
        label: 'label.em.spareparts.emSparePartsInventoryCheckSic.entity.sicPrice',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sicSumPrice',
        label: 'label.em.spareparts.emSparePartsInventoryCheckSic.entity.sicSumPrice',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sicCheckResult',
        label: 'label.em.spareparts.emSparePartsInventoryCheckSic.entity.sicCheckResult',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '盘盈'},
                {value: '2', text: '盘亏'}
            ]
        }
    },
    {
        key: 'sicChecker',
        label: 'label.em.spareparts.emSparePartsInventoryCheckSic.entity.sicChecker',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.em.spareparts.emSparePartsInventoryCheckSic.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    EmSparePartsInventoryCheckSic, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
